var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "h-100", class: [_vm.skinClasses], attrs: { id: "app" } },
    [
      _c(_vm.layout, { tag: "component" }, [_c("router-view")], 1),
      _vm.enableScrollToTop ? _c("scroll-to-top") : _vm._e(),
      _c("last-access-popup", {
        attrs: { "last-access": _vm.lastAccessData },
        model: {
          value: _vm.showLastAccessPopup,
          callback: function($$v) {
            _vm.showLastAccessPopup = $$v
          },
          expression: "showLastAccessPopup"
        }
      }),
      _c("session-timeout-renew-popup"),
      _c("session-timeout-expired-popup")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }